<template>
  <Layout>
    <PageHeader
      :title="title"
      moda_title="Datos del operador"
      ref="pageForm"
      :items="items"
    >
    </PageHeader>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-md-3 col-sm-9">
                <label class="d-inline-flex align-items-center w-100">
                  <!-- <span class="m-2">{{ $t('filter.from') }}: </span> -->
                  <vs-input v-model="filterData.fromDate" type="date" />
                  <vs-input
                    class="ms-2"
                    type="time"
                    v-model="filterData.fromHour"
                    v-if="filterData.fromDate"
                  />
                </label>
              </div>
              <div class="col-md-3 col-sm-9">
                <label class="d-inline-flex align-items-center w-100">
                  <!-- <span class="m-2">{{ $t('filter.until') }}: </span> -->
                  <vs-input v-model="filterData.toDate" type="date" />
                  <vs-input
                    class="ms-2"
                    type="time"
                    v-model="filterData.toHour"
                    v-if="filterData.toDate"
                  />
                </label>
              </div>
            </div>
            <!-- <div class="row mt-4">
              <div
                class="col-sm-12 col-md-12 d-flex justify-content-start"
                @change="getGames"
              >
                <label
                  class="d-inline-flex align-items-center"
                  style="width: max-content"
                >
                  {{ $t('filter.gameType') }}:
                </label>
                <select
                  v-model="filterData.gameType"
                  name="client"
                  class="form-select form-select-sm my-2 ms-2 border-0 shadow-lg w-50"
                  placeholder="Seleccione.."
                >
                  <option disabled selected>
                    {{ $t('helpers.select') }}...
                  </option>
                  <option
                    v-for="(item, index) in mapGamesTypes"
                    :key="index"
                    :value="item.value"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="col-sm-12 col-md-4" v-if="filterData.gameType">
                <label class="d-inline-flex align-items-center w-100">
                  {{ $t('sidebar.games.text') }}:
                  <select
                    v-model="filterData.rouletteId"
                    name="client"
                    class="form-select form-select-sm m-2 border-0 shadow-lg"
                    placeholder="Seleccione.."
                  >
                    <option disabled selected>
                      {{ $t('helpers.select') }}...
                    </option>
                    <option value="*">ALL</option>
                    <option
                      v-for="(item, index) in roulettes"
                      :key="index"
                      :value="item._id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </label>
              </div>
            </div> -->
            <div class="d-flex align-items-center mt-2">
              <vs-button type="button" @click="filtrar">
                {{ $t('filter.filter') }}
              </vs-button>
              <vs-button
                type="button"
                success
                @click="cancelFilter"
                :disabled="!Object.entries(filterData).length"
              >
                {{ $t('filter.cancel') }}
              </vs-button>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6 d-inline-flex align-items-center">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center m-0">
                    {{ $t('filter.show') }}&nbsp;
                    <vs-select v-model="perPage" color="dark" class="shadow-lg">
                      <vs-option
                        v-for="(op, index) in pageOptions"
                        :key="index"
                        :label="op"
                        :value="op"
                        >{{ op }}</vs-option
                      >
                    </vs-select>
                    &nbsp;{{ $t('filter.entries') }}
                  </label>
                </div>
              </div>
            </div>
            <b-overlay :show="loading" rounded="lg">
              <div class="table-responsive mb-0" v-if="tableData.length">
                <b-table
                  id="transaction-table"
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :sort-by="sortBy"
                  :sort-desc="sortDesc"
                >
                <template #table-caption>REGISTROS: {{ tableData.length }} / {{ perPage }}</template>
                </b-table>
              </div>
            </b-overlay>
            <div class="row" v-if="tableData.length">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <button
                      class="btn btn-secondary mx-2 uil-angle-left"
                      @click="beforePage"
                      :disabled="!skip"
                    ></button>
                    <button
                      class="btn btn-primary mx-2 uil-angle-right"
                      @click="nextPage"
                      :disabled="
                        tableData.length > limit || tableData.length < limit
                      "
                    ></button>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main';
import PageHeader from '@/components/page-header-simple';
import { breadCrumbData } from '../../../../helpers/breadcrumbs/breadCrumbs';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: 'Historial de crupier',
      items: breadCrumbData.historyCrupier,
      filterData: {},
      roulettes: [],
      userRole: '',
      userData: '',
      searchActive: false,
      loading: false,
      //Paginacion
      skip: 0,
      limit: 10,
      page: 0,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 1000, 5000],
      filter: null,
      filterOn: ['crupier'],
      sortBy: 'createdAt',
      sortDesc: true,
      tableData: [],
    };
  },
  computed: {
    ...mapGetters({
      mapGames: 'games/getGames',
      mapGamesTypes: 'reports/getGamesTypes',
      userIsClient: 'user/isClient',
      mapData: 'historyCrupier/getHistoryCrupier',
      fields: 'historyCrupier/getFields',
    }),
  },
  methods: {
    async getGames() {
      try {
        if (this.userIsClient) {
          this.getRoulettesClient();
        } else if (this.userRole === 'OPERATOR') {
          this.getRoulettesOperator();
        } else {
          await this.fetchGames({ gameType: this.filterData.gameType });
          this.roulettes = this.mapGames;
        }
      } catch (error) {
        console.log('ERROR GET GAMES', error);
      }
    },
    getUserRole() {
      this.userData = this.$store.getters['user/getUserData'];
      this.userRole = this.userData.rol;

      // if (this.userIsClient) {
      //     this.filterData.clientId = this.userData.client;
      //     this.getOperatorClient();
      //     this.getRoulettesClient();
      // } else if (this.userRole === 'OPERATOR') {
      //     this.filterData.operatorId = this.userData.operator;
      //     this.getRoulettesOperator();
      // } else {
      //     this.getClients();
      //     this.getOperator();
      // }

      // if (!Object.entries(this.$route.query).length) return;

      // this.filtrar();
    },
    async filtrar() {
      this.searchActive = true;
      this.loading = true;

      const filter = {
        ...this.filterData,
        limit: this.limit,
        page: this.currentPage,
      };

      try {
        await this.fetchData(filter);

        this.tableData = this.mapData;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    cancelFilter() {
      this.filterData = {};
      this.currentPage = 1;
      this.searchActive = false;
    },
    nextPage() {
      this.skip += this.limit;
      this.currentPage++;
      this.filtrar();
    },
    beforePage() {
      this.skip -= this.limit;
      this.currentPage--;
      this.filtrar();
    },
    ...mapActions({
      fetchGames: 'games/fetchGames',
      fetchData: 'historyCrupier/fetchHistoryCrupier',
    }),
  },
  watch: {
    perPage() {
      this.skip = 0;
      this.limit = this.perPage;
      this.filtrar();
    },
  },
  mounted() {
    this.getUserRole();
  },
};
</script>

<style lang="scss" scoped></style>
